// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mx-space-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.mx-space-evenly {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.mx-padded-content {
  padding: 20px;
}
.mx-ellipses {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mx-code-mirror-editor {
  border: 1px dashed #e3e3ff;
  height: calc(100% - 30px);
  max-height: 500px;
  overflow: auto;
}
.mx-code-mirror-editor .CodeMirror {
  height: 100%;
}
.mx-full-screen-height {
  height: calc(100vh - 110px);
  min-height: calc(100vh - 110px);
}
.mx-horz-gutter {
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: col-resize;
  background-color: #e4e4e4;
}
.mx-vert-gutter {
  background-repeat: no-repeat;
  background-position: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  cursor: row-resize;
  background-color: #e4e4e4;
}
.mx-text-security {
  text-security: disc;
  -webkit-text-security: disc;
  -moz-text-security: disc;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.src-concept-container {
  white-space: pre-wrap;
}
.src-concept-container .fact-citation {
  margin: 0 4px;
  cursor: pointer;
  color: #07a6f3;
  padding-right: 3px;
  font-style: italic;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/css/mixins.less","webpack://./src/components/playground2/FactCitation.less"],"names":[],"mappings":"AAgBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;ACfF;ADmBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACjBF;ADoBA;EACE,aAAA;AClBF;ADqBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;ACnBF;ADsBA;EACE,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;ACpBF;ADgBA;EAOI,YAAA;ACpBJ;ADwBA;EACE,2BAAA;EACA,+BAAA;ACtBF;ADyBA;EACE,4BAAA;EACA,wBAAA;EACA,yDAAA;EACA,kBAAA;EACA,yBAAA;ACvBF;AD0BA;EACE,4BAAA;EACA,wBAAA;EACA,yDAAA;EACA,kBAAA;EACA,yBAAA;ACxBF;AD2BA;EACE,mBAAA;EACA,2BAAA;EACA,wBAAA;ACzBF;AD+BA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AC7BF;AAnDA;EACE,qBAAA;AAqDF;AAnDE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAqDJ","sourcesContent":[".mx-font-smoothing (@smoothing) when (@smoothing = antialiased) {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: @smoothing;\n  -moz-font-smoothing: @smoothing;\n  -o-font-smoothing: @smoothing;\n  font-smoothing: @smoothing;\n}\n\n.mx-font-smoothing (@smoothing: none) {\n  -webkit-font-smoothing: @smoothing;\n  -moz-font-smoothing: @smoothing;\n  -o-font-smoothing: @smoothing;\n  font-smoothing: @smoothing;\n}\n\n// dashboard style wrap\n.mx-space-wrap {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n// left/right align\n.mx-space-evenly {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.mx-padded-content {\n  padding: 20px;\n}\n\n.mx-ellipses {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mx-code-mirror-editor {\n  border: 1px dashed @border-color;\n  height: calc(~'100% - 30px');\n  max-height: 500px;\n  overflow: auto;\n\n  .CodeMirror {\n    height: 100%;\n  }\n}\n\n.mx-full-screen-height {\n  height: calc(100vh - 110px);\n  min-height: calc(100vh - 110px);\n}\n\n.mx-horz-gutter {\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');\n  cursor: col-resize;\n  background-color: @color-grey-4;\n}\n\n.mx-vert-gutter {\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');\n  cursor: row-resize;\n  background-color: @color-grey-4;\n}\n\n.mx-text-security {\n  text-security: disc;\n  -webkit-text-security: disc;\n  -moz-text-security: disc;\n}\n\n// Adding a new one - Please use prefix mx-\n// Thanks !\n\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n","@import '@css/variables.less';\n@import '@css/mixins.less';\n\n.src-concept-container {\n  white-space: pre-wrap;\n\n  & .fact-citation {\n    margin: 0 4px;\n    cursor: pointer;\n    color: @color-link-blue;\n    padding-right: 3px;\n    font-style: italic;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
